import React, { Component } from 'react'
import "./css/todo.css";

export default class Todo extends Component {
    constructor(props){
        super(props);
        this.state={
            todoList:[],
            
            activeItem:{
                id:null,
                title:"",
                content:"",
                completed:false,
            },
            editing:false
        }
        this.fecthTasks=this.fecthTasks.bind(this);
        this.handleChange=this.handleChange.bind(this);
        this.handleContentChange=this.handleContentChange.bind(this);
        this.handleSubmit=this.handleSubmit.bind(this);
        this.handleEdit=this.handleEdit.bind(this);
        this.handleDelete=this.handleDelete.bind(this);
        this.handleCompleted=this.handleCompleted.bind(this);
        
    }
    
    componentDidMount(){
        this.fecthTasks();
    }
    fecthTasks(){
        // console.log("Fetching")
        var url='https://todo-app-test-ojzi.onrender.com/api/v1/todo'
        fetch(url)
        .then(res=>res.json())
        .then((data)=>{
            
            this.setState({todoList:data?.data})
            console.log(this.state.todoList)
            
          })
          .catch((err)=> {
                console.log(err);
          })
    }
    handleChange(e){
        var value=e.target.value
        this.setState({
            activeItem:{
                ...this.state.activeItem,
                title:value
            }
        })
    }
    handleContentChange(e){
        var value=e.target.value
        this.setState({
            activeItem:{
                ...this.state.activeItem,
                content:value
            }
        })
    }
    handleEdit(task){
        this.setState({
            activeItem:task,
            editing:true
        })
    }
    handleDelete(task){
        
        fetch(`https://todo-app-test-ojzi.onrender.com/api/v1/todo/${task._id}`,{
            method:"DELETE",
            headers:{
                "Content-type":"application/json",
                
            }
         
        })
        .then(res=>{
            this.fecthTasks();
        })
        
    }
    handleSubmit(e){
        e.preventDefault();
        var url="https://todo-app-test-ojzi.onrender.com/api/v1/todo/"
        console.log(this.state.activeItem);
        var method="POST"
        if(this.state.editing===true){    
            url=`https://todo-app-test-ojzi.onrender.com/api/v1/todo/${this.state.activeItem._id}`;
            console.log(url);
            method="PUT";
            this.setState({
                editing:false
            })
        }
        
        fetch(url,{
            method:method,
            headers:{
                "Content-type":"application/json",
                
            },
            body:JSON.stringify(this.state.activeItem)
        })
        .then((res)=>{
            this.fecthTasks();
            this.setState({
                activeItem:{
                    id:null,
                    title:'',
                    content:"",
                    completed:false,

                }
            })
            
        })
        .catch(err=>{
            console.log(err)
        })
    }
    handleCompleted(task){
        task.completed=!task.completed
        var url=`https://todo-app-test-ojzi.onrender.com/api/v1/todo/${task._id}/`
        
        var method="PUT"
        fetch(url,{
            method:method,
            headers:{
                "Content-type":"application/json",
               
            },
            body:JSON.stringify({"completed":task.completed,title:task.title})
        })
        .then((res)=>{
            this.fecthTasks();
        })
        .catch(err=>{
            console.log(err)
        })
    }

    render() {
        var tasks=this.state.todoList;
        
        var self=this;
        return (
            <div className='todo-container'>
                <h1 className="todo-heading">To do app</h1>
                <div className="todo-body">
                    <div >
                        <form className="todo-form" onSubmit={this.handleSubmit}>
                            <div className='todo-form-inputfield'>
                                <input type="text" name="title" onChange={this.handleChange} value={this.state.activeItem.title} placeholder='Enter Task'/>
                                <input type="text" name="content" onChange={this.handleContentChange} value={this.state.activeItem.content} placeholder='Enter description'/>
                            </div>
                            <div className='todo-form-buttonfield'>
                                <input type="submit" value="Add" />
                            </div>
                        </form>
                    </div>
                    <div className="todo-list">
                        {tasks.map((task ,index)=>(
                            <div key={index} className="todo-task-item">
                                <div onClick={()=>self.handleCompleted(task)} className='todo-input-field' style={{flex:6}}> 
                                    {(task.completed===false)?(
                                         <span>
                                            <h2 >{task.title}</h2>
                                            <p>{task.content}</p>
                                         </span>

                                    ):(
                                        <strike>
                                            <h2 >{task.title}</h2>
                                            <p>{task.content}</p>
                                        </strike>
                                    )}
                                   
                                </div>
                                <div style={{flex:1}}>
                                    <button onClick={()=>self.handleEdit(task)} className='todo-button'>edit</button>
                                </div>
                                <div style={{flex:1}}>
                                    <button onClick={()=>self.handleDelete(task)} className='todo-button delete-button'>delete</button>
                                </div>

                            </div>
                         ))
                        }
                    </div>
                </div>
            </div>
        )
    }
}
